export default class Diagnosis {
    constructor(diagnosis, tags_contained) {
      this.diagnosis = diagnosis;
      this.tags_contained = tags_contained
    }

    toObject() {
      return {
        diagnosis: this.diagnosis,
        tags_contained: this.tags_contained,
      };
    }
  }
  